import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.994 18.862l-2.85-2.543a.415.415 0 01.01-.638l2.85-2.543c.317-.291.868-.091.868.32v1.63H19.98c.561 0 1.021.41 1.021.912 0 .501-.46.911-1.021.911H6.872v1.632c0 .41-.551.61-.878.319zM18.006 5.138l2.85 2.543a.415.415 0 01-.01.638l-2.85 2.543c-.317.291-.868.091-.868-.32v-1.63H4.02C3.46 8.911 3 8.501 3 8c0-.501.46-.911 1.021-.911h13.107V5.457c0-.41.551-.61.878-.319z",
      fill: "#2d6ded"
    }
  )
), o = t;
export {
  o as default
};
